import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';
import util from '../../lib/util';

import Top from '../navigation/top';
import Autocomplete from '../form/autocomplete';
import { FormRow } from '../form/formField';

import CategoryTree from './tree';
import CategoryNav from './nav';

const initialState = {
    height: 100,
};

const FIELDS = {
    groupno: { label: 'group #', type: 'text', readonly: true, help: 'Field is imported from Visma: "MainGroupNo", "IntermediateGroupNo", "SubGroupNo" via new Visma SQL -> S3 -> Lambda -> API  files "hovedgruppe.csv", "mellomgruppe.csv", "undergruppe.csv"' },
    name: { label: 'Category name', type: 'text', readonly: true, help: 'Field is imported from Visma: "Name" via new Visma SQL -> S3 -> Lambda -> API  files "hovedgruppe.csv", "mellomgruppe.csv", "undergruppe.csv"' },
    level: { label: 'level', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    sort: { label: 'sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    status: { label: 'Show on DealerWeb', values: [{ key: 'Yes', val: 2 }, { key: 'No', val: 1 }], type: 'radio', readonly: false, help: 'Field is DealerWeb only.' },
    discount: { label: 'Disount in %', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    preSale: { label: 'PS', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    hasNewProducts: { label: 'Has new products', type: 'checkbox', value: 1, readonly: true, help: 'Field is DealerWeb only and updated automatically every day.' },
    showOnConsumerWeb: { label: 'Show on ConsumerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    hasPresaleProducts: { label: 'Has PS products', type: 'checkbox', value: 1, readonly: true, help: 'Field is DealerWeb only and updated automatically every day.' },

    count: { label: 'Total products', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    countPresale: { label: 'Total PS products', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    depth: { label: 'Depth', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

};

@observer
class CategoryEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { articleStore, categoryStore, brandStore, productStore } = this.props.stores;
        categoryStore.load(props.categoryid);
        categoryStore.tree();
        brandStore.load();
        this.subscriptions();

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['groupno', 'name', 'level', 'sort', 'status', 'preSale', 'showOnConsumerWeb',
                    'discount', 'hasNewProducts', 'hasPresaleProducts', 'count', 'countPresale',
                    'depth', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
            {
                tabname: 'Related',
                icon: 'fas fa-user-edit',
                fields: [
                    {
                        name: 'categories',
                        label: 'Related categories',
                        type: 'object',
                        view: (val) => {
                            const opts = {
                                placeholder: 'Search for category...',
                                value: val,
                                valueDisplayMap: v => <span>
                                    <span class='font-weight-light'>{v.groupno}:</span> {v.name}
                                </span>,
                                autocompleteList: categoryStore.searchResults,
                                oninput: (e) => {
                                    clearTimeout(this.searchTimer);
                                    this.searchTimer = setTimeout(async () => {
                                        categoryStore.search(e.target.value);
                                    }, 500);
                                },
                                addElement: (idx) => {
                                    categoryStore.addElement(idx, 'category', 'categories');
                                    categoryStore.resetSearch();
                                },
                                removeElement: (id) => {
                                    categoryStore.removeElement(id, 'category', 'categories');
                                    categoryStore.resetSearch();
                                },
                                handleKeydown: (e) => {
                                    if (e.key === 'ArrowDown') {
                                        if (categoryStore.totalSearch === 0) {
                                            categoryStore.search(e.target.value);
                                        }
                                        categoryStore.incSearchSelectIdx();
                                    } else if (e.key === 'ArrowUp') {
                                        categoryStore.decSearchSelectIdx();
                                    } else if (e.key === 'Enter') {
                                        categoryStore.addElement(0, 'category', 'categories');
                                        categoryStore.resetSearch();
                                    } else if (e.key === 'Escape') {
                                        categoryStore.resetSearch();
                                    }
                                },
                                currentIdx: categoryStore.searchSelectIdx,
                                currentId: categoryStore.searchSelectId,
                                total: categoryStore.totalSearch,
                            };
                            return <Autocomplete {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'articles',
                        label: 'Related articles',
                        type: 'object',
                        view: (val) => {
                            const opts = {
                                placeholder: 'Search for article...',
                                value: val,
                                valueDisplayMap: v => <span>
                                    <span class='font-weight-light'>{v.id}:</span> {v.title}
                                </span>,
                                autocompleteList: articleStore.searchResults,
                                oninput: (e) => {
                                    clearTimeout(this.searchTimer);
                                    this.searchTimer = setTimeout(async () => {
                                        articleStore.search(e.target.value);
                                    }, 500);
                                },
                                addElement: (idx) => {
                                    categoryStore.addElement(articleStore.getElement(idx), 'category', 'articles');
                                    articleStore.resetSearch();
                                },
                                removeElement: (id) => {
                                    categoryStore.removeElement(id, 'category', 'articles');
                                    articleStore.resetSearch();
                                },
                                handleKeydown: (e) => {
                                    if (e.key === 'ArrowDown') {
                                        if (articleStore.totalSearch === 0) {
                                            articleStore.search(e.target.value);
                                        }
                                        articleStore.incSearchSelectIdx();
                                    } else if (e.key === 'ArrowUp') {
                                        articleStore.decSearchSelectIdx();
                                    } else if (e.key === 'Enter') {
                                        categoryStore.addElement(articleStore.getElement(), 'category', 'articles');
                                        articleStore.resetSearch();
                                    } else if (e.key === 'Escape') {
                                        articleStore.resetSearch();
                                    }
                                },
                                currentIdx: articleStore.searchSelectIdx,
                                currentId: articleStore.searchSelectId,
                                total: articleStore.totalSearch,
                            };
                            return <Autocomplete {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'articlesTech',
                        label: 'Related tech articles',
                        type: 'object',
                        view: (val) => {
                            const opts = {
                                placeholder: 'Search for tech article...',
                                value: val,
                                valueDisplayMap: v => <span>
                                    <span class='font-weight-light'>{v.id}:</span> {v.title}
                                </span>,
                                autocompleteList: articleStore.searchResults,
                                oninput: (e) => {
                                    clearTimeout(this.searchTimer);
                                    this.searchTimer = setTimeout(async () => {
                                        articleStore.search(e.target.value);
                                    }, 500);
                                },
                                addElement: (idx) => {
                                    categoryStore.addElement(articleStore.getElement(idx), 'category', 'articlesTech');
                                    articleStore.resetSearch();
                                },
                                removeElement: (id) => {
                                    categoryStore.removeElement(id, 'category', 'articlesTech');
                                    articleStore.resetSearch();
                                },
                                handleKeydown: (e) => {
                                    if (e.key === 'ArrowDown') {
                                        if (articleStore.totalSearch === 0) {
                                            articleStore.search(e.target.value);
                                        }
                                        articleStore.incSearchSelectIdx();
                                    } else if (e.key === 'ArrowUp') {
                                        articleStore.decSearchSelectIdx();
                                    } else if (e.key === 'Enter') {
                                        categoryStore.addElement(articleStore.getElement(), 'category', 'articlesTech');
                                        articleStore.resetSearch();
                                    } else if (e.key === 'Escape') {
                                        articleStore.resetSearch();
                                    }
                                },
                                currentIdx: articleStore.searchSelectIdx,
                                currentId: articleStore.searchSelectId,
                                total: articleStore.totalSearch,
                            };
                            return <Autocomplete {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'products',
                        label: 'Related products',
                        type: 'object',
                        view: (val) => {
                            const opts = {
                                placeholder: 'Search for product...',
                                value: val,
                                valueDisplayMap: v => <span>
                                    <span class='font-weight-light'>{v.articleno}:</span> {v.name}
                                </span>,
                                autocompleteList: productStore.searchResults,
                                oninput: (e) => {
                                    clearTimeout(this.searchTimer);
                                    this.searchTimer = setTimeout(async () => {
                                        productStore.search(e.target.value);
                                    }, 500);
                                },
                                addElement: (idx) => {
                                    categoryStore.addElement(productStore.getElement(idx), 'category', 'products');
                                    productStore.resetSearch();
                                },
                                removeElement: (id) => {
                                    categoryStore.removeElement(id, 'category', 'products');
                                    productStore.resetSearch();
                                },
                                handleKeydown: (e) => {
                                    if (e.key === 'ArrowDown') {
                                        if (productStore.totalSearch === 0) {
                                            productStore.search(e.target.value);
                                        }
                                        productStore.incSearchSelectIdx();
                                    } else if (e.key === 'ArrowUp') {
                                        productStore.decSearchSelectIdx();
                                    } else if (e.key === 'Enter') {
                                        categoryStore.addElement(productStore.getElement(), 'category', 'products');
                                        productStore.resetSearch();
                                    } else if (e.key === 'Escape') {
                                        productStore.resetSearch();
                                    }
                                },
                                currentIdx: productStore.searchSelectIdx,
                                currentId: productStore.searchSelectId,
                                total: articleStore.totalSearch,
                            };
                            return <Autocomplete {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                ],
            },
        ];
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    updateField = async (id, field, value) => {
        const { categoryStore } = this.props.stores;
        categoryStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { categoryStore } = this.props.stores;
        await categoryStore.saveField(id, field, value);
    }

    render(props) {
        const { height } = this.state;
        const { categoryStore } = this.props.stores;
        const { category, saved } = categoryStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <CategoryNav {...this.props} />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <CategoryTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>
                        <div class='d-flex flex-row bd-highlight mb-3 mt-4'>
                            <div>
                                <a href='/categories' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {category.id}: {category.name}</h4>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/categories/${props.categoryid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={category}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryEdit;



// WEBPACK FOOTER //
// ./components/categories/edit.js